<form (submit)="onSave()">
  <div class="form-group">
    <textarea class="comment-area" name="comment" [(ngModel)]="comment" rows="4"></textarea>
  </div>
  <button type="submit" class="save-btn">Сохранить</button>
</form>
